import React, { useState } from "react";
import { SharePointInputData } from "../../src/taskpane/interfaces/props/SharePointInputData";
import SaveWithMetaData from "../../src/taskpane/components/directoryComponents/sharepoint/SaveToSharepoint";
import { FontIcon, IButtonStyles, Icon, IPanelProps, IPanelStyles, IRenderFunction, IStackItemStyles, IStackStyles, IStackTokens, Label, mergeStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, ScrollablePane, ScrollbarVisibility, Spinner, SpinnerSize, Stack, TooltipHost } from "@fluentui/react";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { CheckinTypes, CreateDocumentFromTemplateRequest, FilePreCommitRequest, MetadataDto, MetadataUpdateRequest, ReplaceFileRequest, UpdateTriggerAction } from "../../src/taskpane/components/_v2/redux/api/local/api-local-interfaces";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { useDispatch, useSelector } from "react-redux";
import authModule from "../../utilities/AuthModule";
import { FileIconType, getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { useMetaDataFormInputs } from "../Body/useMetaDataFormInputs";
import { Slide, ToastContainer } from "react-toastify";
import { customToast } from "../../src/taskpane/components/CustomToast";
import { DocubirdCache, internalSharepointName, officeFileType, SharePointFolderContentTypeIds, sharePointInternalFileName } from "../../src/taskpane/config/constants";
import { IDocUrlDropdown } from "../../src/taskpane/interfaces/IDocUrlDropdown";
import UploaderContainer from "../../src/taskpane/components/panels/UploaderContainer";
import { Fileview } from "../../src/taskpane/components/_v2/components/Explorer/Fileview/Fileview";
import { isMobile, mobileListItemStyle } from "../../src/taskpane/styles/mobileStyles";
import { useLazyCreateDocumentAndGetEditLinkQuery, useLazyDeleteVersionByLabelQuery, useLazyGetItemByUniqueIDQuery, useLazyGetItemVersionsQuery, useLazyPublishItemQuery } from "../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { IVersionSelectorProps, VersionSelector } from "../../src/taskpane/components/_v2/_shared/VersionSelector/VersionSelector";
import { resetFiles } from "../../src/taskpane/redux/modules/file";
import { IFileToUpload } from "../../src/taskpane/interfaces/IFileToUpload";
import generalModule from "../../utilities/GeneralModule";
import { logger } from "../../utilities/logger";
import { ModeEnum } from "../../src/taskpane/components/enums/modeEnum";
import { OutlookUtils } from "../../utilities/OutlookUtils";
import { OutlookService } from "../../src/taskpane/services/OutlookService";
import { FileService } from "../../src/taskpane/services/FileService";
import { tryEncodeUriComponent } from "../../utilities/EncodeDecode";
import dayjs from "dayjs";
import { getFilePreCommitInfo, getFileVersionData, getItemAbsoluteUrl, getListSettings, getUserEffectivePermissions, getUserEffectivePermissionsFromMask } from "../../src/taskpane/services/SharePointRestServices";
import { currentSharepointFolderState, currentSharepointFolderUserPermissions } from "../../src/taskpane/redux/models/reduxModels";
import { IOutlookRestDto } from "../../src/taskpane/interfaces/IOutlookRestDto";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { IFilePreCommitResult } from "../../src/taskpane/interfaces/IFilePreCommitResult";
import { SearchOpenExtensionHelper } from "../../src/taskpane/components/helpers/SearchOpenExtensionHelper";
import { CMCheckinModal } from "./CMCheckinModal";
import { CMConfirmModal } from "./CMConfirmModal";
import { CacheHelper } from "../../utilities/CacheHelper";
import { apiFileCreateDocumentFromTemplate, apiFileReplace, apiUpdateItemMetadata } from "../../src/taskpane/services/ApiService";
import { getContainerSharePointIds, getDriveRootWebUrl } from "../../src/taskpane/services/GraphService";
import { NewDocumentTemplate } from "../../src/taskpane/interfaces/IDocumentTemplate";
import { DatasourceTypeEnum } from "../../src/taskpane/components/enums/datasourceTypeEnum";
import { useWindowSize } from "../Hooks/useWindowSize";
// import { updateExcelXML, updateWordXML } from "../../src/taskpane/services/OfficeCustomXmlService";

export const scrollStyle = mergeStyles({
    position: "relative",
    height: "calc(100vh - 140px)",
    marginTop: 5,
    marginBottom: 10
});

export const panelActionButtonStyle: Partial<IButtonStyles> = {
    root: {
        marginTop: 20,
    }
}

const tooltipHostCalloutProps = { gapSpace: 7 };

const panelStyles: Partial<IPanelStyles> = {
    content: {
        paddingLeft: 5,
        paddingRight: 5
    },
    navigation: {
        justifyContent: "space-between",
        marginTop: 5
    }
}

const uploaderContainerStyles: React.CSSProperties = {
    marginBottom: 10
};

const fileNameContainerTokens: IStackTokens = {
    childrenGap: 10
};

const fileIconContainerStyles: IStackStyles = {
    root: {
        display: "flex"
    }
};

const fileNameContainerStyles: IStackStyles = {
    root: {
        margin: 5,
        paddingLeft: 10,
        minWidth: 0
    }
};

const fileNameTextContainerStyles: IStackStyles = {
    root: {
        minWidth: 0
    }
};

const defaultCloseButtonContainerStyles: React.CSSProperties = {
    marginRight: 14,
    display: "flex"
}

const showMoreContainerStyles: React.CSSProperties = {
    marginTop: 5
}

const paddedContainerStyles: React.CSSProperties = {
    paddingBottom: 10
}

const fileNameTextStyles = mergeStyles({
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: 600,
});

const minItems = 5;

export enum InfoPanelMode {
    Update,
    Replace,
    NewTemplate
}

interface IUpdateErrorDetails {
    isError: boolean;
    details?: string;
}

export interface ICMFileInfoPanelProps {
    item?: any;
    panelIsOpen: boolean;
    selectedDocumentLibrary?: IDocUrlDropdown;
    infoPanelMode?: InfoPanelMode;
    webAddinItem?: any;
    selectedTemplate?: NewDocumentTemplate;
    folderPath?: string;
    userPermissions?: currentSharepointFolderUserPermissions;
    keepOpenOnSave?: boolean;
    filePreview?: JSX.Element;
    closePanel: () => void;
    closeOnSuccess: (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention?: string, replacementFile?: IFileToUpload) => void;
    onItemUpdated?: () => void;
}

export const CMFileInfoPanel = ({ item, panelIsOpen, selectedDocumentLibrary, infoPanelMode, webAddinItem, selectedTemplate, folderPath, userPermissions, keepOpenOnSave, filePreview, closePanel, closeOnSuccess, onItemUpdated }: ICMFileInfoPanelProps) => {
    const languageStrings = React.useContext(LanguageContext);
    const dispatch = useDispatch();

    const workingDirectories = useSelector((state: RootState) => state.workingDirectories?.workingDirectories);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories?.workingDirectories?.length > 0 ? state.workingDirectories?.workingDirectories[state.workingDirectories?.workingDirectories?.length - 1] : null);
    const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories?.oneDriveRootDetails);
    const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
    const userAccount = useSelector((state: RootState) => state.user?.account);
    const files = useSelector((state: RootState) => state.files?.files);
    const mode = useSelector((state: RootState) => state.mode.mode);
    const tenantReplaceFileNameWithGUID = useSelector((state: RootState) => state.tenantInfo?.replaceFileNameWithGUID);
    const tenantOpenDocumentsInClientApp = useSelector((state: RootState) => state.tenantInfo?.openDocumentsInClientApp);
    const tenantDisableAutoOpenAfterNewFileFromTemplate = useSelector((state: RootState) => state.tenantInfo?.disableAutoOpenAfterNewFileFromTemplate);
    const minVersionLimit = useSelector((state: RootState) => state.tenantInfo.minVersionLimit);
    const requiredMetadataOnPublish = useSelector((state: RootState) => state.tenantInfo.requiredMetadataOnPublish);
    const autoDeleteMinorVersionsOnPublish = useSelector((state: RootState) => state.tenantInfo.autoDeleteMinorVersionsOnPublish);

    const [getItemByUniqueId] = useLazyGetItemByUniqueIDQuery();
    const [createDocumentAndGetEditLink] = useLazyCreateDocumentAndGetEditLinkQuery();
    const [publishItem] = useLazyPublishItemQuery();
    const [getItemVersions] = useLazyGetItemVersionsQuery();
    const [deleteVersionByLabel] = useLazyDeleteVersionByLabelQuery();

    const [isBusy, setIsBusy] = React.useState(false);
    const [showSelectVersion, setShowSelectVersion] = React.useState(false);
    const [replacementFileView, setReplacementFileView] = React.useState<JSX.Element>();
    const [selectedOutlookFileViews, setSelectedOutlookFileViews] = React.useState<JSX.Element[]>([]);
    const [versionProps, setVersionProps] = React.useState<IVersionSelectorProps>();
    const [checkinType, setCheckinType] = React.useState<CheckinTypes>();
    const [replacementFile, setReplacementFile] = React.useState<IFileToUpload>();
    const [selectedItem, setSelectedItem] = React.useState<any>();
    const [sectionStyle, setSectionStyle] = React.useState<any>();
    const [selectedContentTypeId, setSelectedContentTypeId] = useState<string>(selectedItem?.contenttypeid ?? selectedItem?.ContentTypeId);
    const [showMoreIsClicked, setShowMore] = React.useState<boolean>(false);
    const [showMessageBar, setShowMessageBar] = React.useState(true);
    const [currentSharepointFolderInfo, setCurrentSharepointFolderInfo] = React.useState<currentSharepointFolderState>(currentSharepointFolder);
    const [isCurrentDirectorySPList, setIsCurrentDirectorySPList] = React.useState<boolean>(false);
    const [showSaveSuccessIndicator, setShowSaveSuccessIndicator] = React.useState<boolean>(false);
    const [showConfirmPublishDialog, setShowConfirmPublishDialog] = React.useState<boolean>(false);
    const [showCheckinDialog, setShowCheckinDialog] = React.useState(false);
    const [updateRequest, setUpdateRequest] = React.useState<MetadataUpdateRequest>();
    const [currentMinorVersion, setCurrentMinorVersion] = React.useState<number>();
    const [fileUpdated, setFileUpdated] = React.useState("");
    const [requiredMetadataValueChanged, setRequiredMetadataValueChanged] = React.useState(false);
    const [permissionsLoaded, setPermissionsLoaded] = React.useState(false);
    const [updateItemErrorDetails, setUpdateItemErrorDetails] = React.useState<IUpdateErrorDetails>();
    const userPermissionsRef = React.useRef<currentSharepointFolderUserPermissions>(currentSharepointFolder?.userPermissions);

    const windowSize = useWindowSize();

    const { inputValuesToSave, itemWebUrl, itemSharepointListId, fieldsLoaded, updateSharepointMetadataToSave, mapColumnsToSaveFields, mapColumnsToSaveFieldsOneDrive, extention, validateName, setFieldsLoaded, checkIfInOneDrive, setInputValuesToSave } = useMetaDataFormInputs(item, selectedDocumentLibrary, infoPanelMode, webAddinItem, selectedTemplate);

    const isInOneDrive = React.useRef(checkIfInOneDrive());
    const isCurrentOfficeFile = React.useRef<boolean>(false);

    const removeMessage = React.useCallback(() => setShowMessageBar(false), []);

    const setIsUpdateError = React.useCallback((isError: boolean, details?: string) => {
        setUpdateItemErrorDetails({
            isError,
            details: details
                ? `${languageStrings.ErrorMessageGeneric} - ${details}`
                : languageStrings.ErrorMessageGeneric
        });
    }, [setUpdateItemErrorDetails]);

    React.useEffect(() => {
        if (workingDirectories && workingDirectories.some(x => x.type === ComponentTypes.SharePointList)) {
            setIsCurrentDirectorySPList(true);
        }
    }, [workingDirectories]);

    React.useEffect(() => {
        generalModule.setIsFileInfoPanelOpen(true);
        if (item) {
            setSelectedItem(item);
        } else if (webAddinItem) {
            (async () => {
                try {
                    let currentFileUniqueId: string = webAddinItem.sharepointIds?.listItemUniqueId;
                    if (currentFileUniqueId) {
                        CacheHelper.set(DocubirdCache.currentFileUniqueId, currentFileUniqueId);
                        let officeFileUniqueId: string = CacheHelper.get(DocubirdCache.officeFileUniqueId);
                        if (officeFileUniqueId && currentFileUniqueId === officeFileUniqueId) {
                            isCurrentOfficeFile.current = true;
                        }

                        const file = await getItemByUniqueId({
                            siteUrl: webAddinItem.sharepointIds?.siteUrl,
                            sharePointListId: webAddinItem.sharepointIds?.listId,
                            uniqueId: currentFileUniqueId,
                            accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                        }).unwrap();

                        setSelectedItem({ ...file, name: webAddinItem.name });
                    }
                } catch (error) {
                    logger(error, "CMFileInfoPanel.tsx (getItemByUniqueId - init)");
                }
            })();
        }
    }, [item, webAddinItem]);

    // React.useEffect(() => {
    //     if (updateItemErrorDetails?.isError) {
    //         generateToastError([updateItemErrorDetails.details ?? languageStrings.ErrorMessageGeneric]);
    //     }
    // }, [updateItemErrorDetails]);

    React.useEffect(() => {
        (async () => {
            try {
                const accessToken = isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken();

                let webUrl: string;
                let listId: string;
                let uniqueId: string;
                let userItemPermissions: currentSharepointFolderUserPermissions = userPermissions;

                if (webAddinItem) {
                    webUrl = webAddinItem.sharepointIds?.siteUrl;
                    listId = webAddinItem.sharepointIds?.listId;
                    uniqueId = webAddinItem.sharepointIds?.listItemUniqueId;
                }
                else if (selectedDocumentLibrary) {
                    webUrl = selectedDocumentLibrary.webUrl;
                    listId = selectedDocumentLibrary.sharePointListId;
                    uniqueId = item.uniqueid;
                }
                else {
                    webUrl = currentDirectory?.webUrl;
                    listId = currentDirectory?.sharePointListId;
                    uniqueId = item?.UniqueId?.replace("{", "").replace("}", "");

                    if (item?.PermMask) {
                        userItemPermissions = getUserEffectivePermissionsFromMask(item.PermMask);
                    }
                }

                const refreshSettings = !currentSharepointFolder?.sharepointListId || currentSharepointFolder?.sharepointListId !== listId;
                const refreshPermissions = !userItemPermissions && uniqueId;

                if (webUrl && listId) {
                    const [settings, permissions] = await Promise.all([
                        refreshSettings && getListSettings(accessToken, webUrl, listId),
                        refreshPermissions && getUserEffectivePermissions(accessToken, webUrl, listId, uniqueId)
                    ]);

                    setCurrentSharepointFolderInfo({
                        sharepointListId: listId,
                        canView: false,
                        canCreateFolder: refreshSettings && settings ? settings.EnableFolderCreation : currentSharepointFolder?.canCreateFolder ?? false,
                        contentTypesEnabled: refreshSettings && settings ? settings.ContentTypesEnabled : currentSharepointFolder?.contentTypesEnabled ?? false,
                        enableMinorVersions: refreshSettings && settings ? settings.EnableMinorVersions : currentSharepointFolder?.enableMinorVersions ?? false,
                        forceCheckout: refreshSettings && settings ? settings.ForceCheckout : currentSharepointFolder?.forceCheckout ?? false,
                        userPermissions: refreshPermissions ? permissions : userItemPermissions
                    });

                    userPermissionsRef.current = refreshPermissions ? permissions : userItemPermissions
                }
                else {
                    setCurrentSharepointFolderInfo({ ...currentSharepointFolder });
                }

                setPermissionsLoaded(true);
            } catch (error) {
                logger(error, "CMFileInfoPanel.tsx (getListSettings - useEffect)");
            }
        })();
    }, [currentSharepointFolder, item, webAddinItem, selectedDocumentLibrary]);

    React.useEffect(() => {
        if (currentSharepointFolderInfo?.enableMinorVersions === true) {
            if (itemWebUrl && selectedItem) {
                (async () => {
                    const fileVersionData = await getFileVersionData(
                        isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                        itemWebUrl,
                        webAddinItem ? webAddinItem.sharepointIds?.listItemUniqueId : selectedItem.uniqueid ? selectedItem.uniqueid : selectedItem.UniqueId?.replace("{", "").replace("}", "")
                    );

                    if (fileVersionData) {
                        setVersionProps({
                            multipleFilesSelected: false,
                            level: fileVersionData.Level,
                            majorVersion: fileVersionData.MajorVersion,
                            minorVersion: fileVersionData.MinorVersion
                        });
                    }
                })();
            }
            else if (selectedTemplate?.datasource?.type?.id === DatasourceTypeEnum.SharePointDocumentTemplate) {
                setVersionProps({
                    multipleFilesSelected: true,
                    level: 2,
                    majorVersion: 0,
                    minorVersion: 0
                });
            }
        }
    }, [currentSharepointFolderInfo?.enableMinorVersions, itemWebUrl, selectedItem, fileUpdated, selectedTemplate]);

    React.useEffect(() => {
        if (minVersionLimit > 0 && versionProps) {
            setCurrentMinorVersion(versionProps.minorVersion ?? 0);
        }
    }, [minVersionLimit, versionProps]);

    React.useEffect(() => {
        if (files?.length > 0 && selectedItem) {
            const selectedFileExtention = getFileExtension()?.trim().toLowerCase();
            setSelectedOutlookFileViews(files.filter(x => x.extension?.trim().toLowerCase() === selectedFileExtention).map((file, index) => {
                return (<div key={index}>
                    <Fileview
                        item={{ ...file, driveId: '', fileType: file.extension }}
                        isMobile={isMobile()}
                        multiSelect={false}
                        hasShowMore={false}
                        tenantEnablePII={false}
                        isLocalFile={true}
                        itemSelected={outlookItemSelected}
                    />
                </div>)
            }));
        }
    }, [files, selectedItem]);

    React.useEffect(() => {
        if (replacementFile) {
            setReplacementFileView(
                <Fileview
                    item={{ ...replacementFile, driveId: '', lastModifiedDateTime: replacementFile.lastModifiedDateTime, fileType: replacementFile.extension }}
                    isMobile={isMobile()}
                    multiSelect={false}
                    hasShowMore={false}
                    tenantEnablePII={false}
                    isLocalFile={true}
                    fileRemoved={() => setReplacementFile(null)}
                />
            );
        }
    }, [replacementFile]);

    React.useEffect(() => {
        const itemHeight = isMobile() ? mobileListItemStyle.height : 40;
        let containerHeight = itemHeight * selectedOutlookFileViews?.length;

        if (!showMoreIsClicked) {
            containerHeight = selectedOutlookFileViews?.length > minItems ? itemHeight * minItems : itemHeight * selectedOutlookFileViews?.length;
        }

        setSectionStyle(
            mergeStyles({
                maxHeight: containerHeight,
                overflow: "hidden",
                transition: "max-height 0.5s ease-in-out"
            })
        );
    }, [showMoreIsClicked, selectedOutlookFileViews]);

    React.useEffect(() => {
        let timeOutId: NodeJS.Timeout;
        if (showSaveSuccessIndicator) {
            timeOutId = setTimeout(() => {
                setShowSaveSuccessIndicator(false);
            }, 800);
        }
        return () => {
            if (timeOutId) {
                clearTimeout(timeOutId);
            }
        }
    }, [showSaveSuccessIndicator, setShowSaveSuccessIndicator]);

    React.useEffect(() => {
        let hasChanged = false;

        if (requiredMetadataOnPublish && inputValuesToSave) {
            const requiredMetaFieldsInternalNames: string[] = requiredMetadataOnPublish.split(",");
            for (let index = 0; index < inputValuesToSave.length; index++) {
                const inputValue = inputValuesToSave[index];
                if (inputValue?.displayName && requiredMetaFieldsInternalNames.some(x => x.toLowerCase() === inputValue.displayName.toLowerCase())) {
                    const originalValue = CacheHelper.get(inputValue.internalName);

                    let newValue: any;
                    if (inputValue.type === "TaxonomyFieldType") {
                        newValue = Array.isArray(inputValue.value?.terms)
                            ? inputValue.value.terms.map(x => x.label).join(",")
                            : Array.isArray(inputValue.value)
                                ? inputValue.value.join(",")
                                : null;
                    }
                    else if (inputValue.type === "TaxonomyFieldTypeMulti") {
                        newValue = Array.isArray(inputValue.value?.terms)
                            ? inputValue.value.terms.map(x => x.label).join(",")
                            : Array.isArray(inputValue.value)
                                ? inputValue.value?.map(x => x.Label).join(",")
                                : null;
                    }
                    else {
                        newValue = inputValue.value;
                    }

                    if (originalValue !== (newValue ? JSON.stringify(newValue.toString()) : "")) {
                        hasChanged = true;
                        break;
                    }
                }
            }
        }

        setRequiredMetadataValueChanged(hasChanged);
    }, [inputValuesToSave, requiredMetadataOnPublish]);

    const outlookItemSelected = (item: IFileToUpload) => {
        setReplacementFile(item);
    }

    const sharepointDataIsValid = async (forceNameCheck: boolean = false) => {
        const inputValues = [...inputValuesToSave];

        if (forceNameCheck
            || (infoPanelMode !== InfoPanelMode.Replace && (infoPanelMode !== InfoPanelMode.NewTemplate || !tenantReplaceFileNameWithGUID))) {
            const nameField = inputValues.find(x => x.internalName === sharePointInternalFileName);
            if (nameField) await validateName(nameField, selectedItem, forceNameCheck);
        }

        const itemsWithErrors = inputValues.filter(item => item.hasError === true).map(item => item.errorMessage ? `${item.displayName} - ${item.errorMessage}` : item.displayName);

        if (itemsWithErrors.length > 0) {
            generateToastError(itemsWithErrors);
        }

        return itemsWithErrors.length === 0;
    };

    const generateToastError = (items: string[]) => {
        customToast.error(
            <div>
                <strong>{languageStrings.MetadataValidationFailed}</strong><br />
                {generateErrors(items)}
            </div>
        );
    };

    const generateErrors = (items: string[]) => {
        return items.map((item, index) => {
            return (
                <span key={index}>
                    &bull; {item} <br />
                </span>
            );
        });
    };

    const saveMetadata = async () => {
        setIsBusy(true);
        try {
            const isValidSharepointData = await sharepointDataIsValid();
            if (isValidSharepointData) {
                const contentTypeMeta: MetadataDto = {
                    type: "Content",
                    internalName: internalSharepointName.contentTypeId,
                    value: selectedContentTypeId
                }

                let request: MetadataUpdateRequest = {
                    accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                    tenantGuid: userAccount?.tenantId,
                    accountId: userAccount?.accountId,
                    siteUrl: isInOneDrive.current ? oneDriveRootDetails.sharePointSiteUrl : itemWebUrl,
                    listId: itemSharepointListId,
                    teamId: workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId,
                    channelId: workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId,
                    listItemUniqueId: webAddinItem ? webAddinItem?.sharepointIds?.listItemUniqueId : selectedItem?.uniqueid ?? selectedItem?.UniqueId?.replace('{', '').replace('}', ''),
                    isFolder: selectedItem?.contenttypeid ? selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder) : selectedItem?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder),
                    isListItem: isCurrentDirectorySPList ? true : false,
                    listSettings: {
                        enableMinorVersions: currentSharepointFolderInfo?.enableMinorVersions === true,
                    },
                    triggeredByAction: UpdateTriggerAction.Default,
                    metadata: inputValuesToSave.map(input => {
                        const meta: MetadataDto = {
                            type: input.type,
                            internalName: input.internalName,
                            value: !(input?.value === 0) && (!input?.value || (Array.isArray(input?.value) && !input?.value?.length)) ? undefined : input.value
                        }
                        return meta;
                    })
                }

                request.metadata.unshift(contentTypeMeta);

                let isNormalUpdate = true;
                if (currentMinorVersion >= (minVersionLimit - 1) && !requiredMetadataValueChanged) {
                    isNormalUpdate = false;
                    setShowConfirmPublishDialog(true);
                    setUpdateRequest(request);
                }

                if (isNormalUpdate) {
                    try {
                        setIsUpdateError(false);
                        await updateOfficeXML();
                        await apiUpdateItemMetadata(request);

                        //one of the required meta fields' values changed
                        //publish & then delete minor versions if applicable
                        if (requiredMetadataValueChanged) {
                            const uniqueId = webAddinItem ? webAddinItem.UniqueId ? webAddinItem.UniqueId : webAddinItem.sharepointIds.listItemUniqueId : item.UniqueId.replace("{", "").replace("}", "");
                            try {
                                await publishItem({
                                    siteUrl: isInOneDrive.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl,
                                    uniqueId,
                                    accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                                    comment: ""
                                }).unwrap();

                            } catch (error) {
                                logger(error, "CMCFileInfoModal.tsx (onConfirmCheckin - publish)");
                            }

                            if (autoDeleteMinorVersionsOnPublish) {
                                try {
                                    const itemVersions = await getItemVersions({
                                        siteUrl: currentDirectory?.webUrl,
                                        uniqueId,
                                        accessToken: await authModule.getSharePointAccessToken(),
                                    }).unwrap();

                                    const versions = itemVersions.d?.results;

                                    if (versions && versions.length > 0) {
                                        await Promise.all(versions.map(async version => {
                                            if (!version.IsCurrentVersion && version.ID % 512 > 0) {
                                                deleteVersionByLabel({
                                                    siteUrl: isInOneDrive.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl,
                                                    uniqueId,
                                                    accessToken: await authModule.getSharePointAccessToken(),
                                                    versionLabel: version.VersionLabel
                                                }).unwrap();
                                            }
                                        }));
                                    }
                                } catch (error) {
                                    logger(error, "CMCheckinMoadal.tsx (autoDeleteMinorVersionsOnPublish)");
                                }
                            }
                        }

                        // if (keepOpenOnSave) {
                        //     setShowSaveSuccessIndicator(true);
                        //     setFileUpdated(Date.now().toString());
                        // }
                        // else {
                        //     generalModule.setIsFileInfoPanelOpen(false);
                        //     closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention);
                        // }
                        setShowSaveSuccessIndicator(true);
                        setFileUpdated(Date.now().toString());
                        if (onItemUpdated) onItemUpdated();
                    } catch (error) {
                        logger(error, "CMFileInfoPanel.tsx (updateItemMetadata)");
                        setIsBusy(false);
                        setIsUpdateError(true, error?.response?.data ?? error?.message);
                    }
                }
            }
        } catch (error) {
            logger(error, "CMFileInfoPanel.tsx (saveMetadata)");
        }
        setIsBusy(false);
    }

    const updateOfficeXML = async () => {
        try {
            // if (!generalModule.isInConentMangerMode() && mode === ModeEnum.office) {
            //     if (Office.context.requirements.isSetSupported("WordApi", "1.1") && Office.context.document?.customXmlParts?.getByNamespaceAsync) {
            //         await updateWordXML(updatedInputValues);
            //     }
            //     else if (Office.context.requirements.isSetSupported("ExcelApi", "1.11")) {
            //         await updateExcelXML(updatedInputValues);
            //     }
            //     setInputValuesToSave(updatedInputValues);
            //     await new Promise(res => setTimeout(res, 2000));
            // }
            if (!generalModule.isInConentMangerMode() && mode === ModeEnum.office) {
                if (Office.context.requirements.isSetSupported("WordApi", "1.1")) {
                    await Word.run(async (context) => {
                        context.document.save();
                        await context.sync();
                    });
                }
                else if (Office.context.requirements.isSetSupported("ExcelApi", "1.11")) {
                    await Excel.run(async (context) => {
                        if (context?.workbook) {
                            context.workbook.save(Excel.SaveBehavior.save);
                            await context.sync();
                        }
                    });
                }
                // setInputValuesToSave(updatedInputValues);
                await new Promise(res => setTimeout(res, 1000));
            }
        } catch (error) {
            logger(error, "CMFileInfoPanel.tsx (updateOfficeXML)");
        }
    }

    const createNewNemplate = async () => {
        setIsBusy(true);
        try {
            const isValidSharepointData = await sharepointDataIsValid(true);

            if (isValidSharepointData) {
                let siteUrl: string = isInOneDrive.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;
                let filename: string;
                if (tenantReplaceFileNameWithGUID) {
                    const retryLimit: number = 10;
                    let attempt: number = 0;
                    do {
                        filename = `${dayjs.utc().format('YYMM-SSS')}${dayjs.utc().format('SSS').charAt(0)}`;

                        let destinationUrl: string;
                        if (isInOneDrive.current) {
                            destinationUrl = `${currentDirectory?.webUrl}${currentDirectory.directory ? `${currentDirectory.directory}` : ''}`
                        } else if (currentDirectory?.isTeamsRootFolder && !currentDirectory.parentId) {
                            destinationUrl = await getDriveRootWebUrl(currentDirectory.id);
                        } else {
                            destinationUrl = `${siteUrl}${currentDirectory.directory ? `/${currentDirectory.directory}` : ''}`;
                        }

                        const fileRequest: FilePreCommitRequest = {
                            accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                            destinationUrl,
                            siteUrl,
                            fileName: `${filename}.${selectedTemplate.extention}`,
                            autoFolderCreation: false
                        }

                        const preCommitResult: IFilePreCommitResult = await getFilePreCommitInfo(fileRequest);
                        if (!preCommitResult || preCommitResult.exists === false) {
                            break;
                        }
                    } while (++attempt < retryLimit);
                }
                else {
                    filename = inputValuesToSave.find(x => x.internalName === sharePointInternalFileName)?.value;
                }

                let newFileId: any;
                let editLink: string;
                let allowOpenLink: boolean = true;

                if (selectedTemplate?.datasource?.type?.id === DatasourceTypeEnum.SharePointDocumentTemplate) {

                    if (currentSharepointFolderInfo?.enableMinorVersions === true && showSelectVersion === false) {
                        setShowSelectVersion(true);
                        setIsBusy(false);
                        return;
                    }

                    const driveId: string = !isInOneDrive.current ? (!currentDirectory.parentId ? currentDirectory.id : currentDirectory.parentId) : oneDriveRootDetails.driveId;
                    const itemId: string = !currentDirectory?.parentId ? null : currentDirectory?.id;
                    const destSharePointIds = await getContainerSharePointIds(driveId, itemId);
                    if (destSharePointIds) {
                        const destSiteUrl: string = destSharePointIds.siteUrl;
                        const destListId: string = destSharePointIds.listId;
                        const destFolderUniqueId: string = destSharePointIds.listItemUniqueId;
                        const templateSiteUrl: string = selectedTemplate.datasource.url;
                        const templateUniqueId: string = selectedTemplate.templateId;
                        const teamId: string = workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId;
                        const channelId: string = workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId;

                        const createDocumentFromTemplateRequest: CreateDocumentFromTemplateRequest = {
                            destAccessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                            templateAccessToken: await authModule.getSharePointAccessToken(),
                            tenantGuid: userAccount?.tenantId,
                            accountId: userAccount?.accountId,
                            destSiteUrl,
                            destListId,
                            destFolderUniqueId,
                            templateSiteUrl,
                            templateUniqueId,
                            teamId,
                            channelId,
                            fileName: filename,
                            checkinType: currentSharepointFolderInfo?.enableMinorVersions === true ? (checkinType ? checkinType : CheckinTypes.minorCheckIn) : undefined,
                            metadata: inputValuesToSave
                                .filter(x => x.internalName !== sharePointInternalFileName)
                                .map(input => {
                                    const meta: MetadataDto = {
                                        type: input.type,
                                        internalName: input.internalName,
                                        displayName: input.displayName,
                                        value: !(input?.value === 0) && (!input?.value || (Array.isArray(input?.value) && !input?.value?.length)) ? undefined : input.value
                                    }
                                    return meta;
                                })
                        };

                        const createdDocumentRes = await apiFileCreateDocumentFromTemplate(createDocumentFromTemplateRequest);
                        newFileId = createdDocumentRes?.value;
                        if (newFileId && tenantOpenDocumentsInClientApp && !tenantDisableAutoOpenAfterNewFileFromTemplate) {
                            try {
                                const absUrl = await getItemAbsoluteUrl(isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(), siteUrl, itemSharepointListId, newFileId);
                                if (absUrl) {
                                    const fileInfo = SearchOpenExtensionHelper.determineOfficeFileType(selectedTemplate.extention);
                                    if (fileInfo?.localUrlPrepended) {
                                        editLink = `${fileInfo.localUrlPrepended}${absUrl}`;
                                    }
                                }
                            } catch (error) {
                                logger(error, "CMFileInfoPanel.tsx (getItemAbsoluteUrl)");
                            }
                        }
                    }
                }
                else {
                    const results = await createDocumentAndGetEditLink({
                        siteUrl,
                        accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                        sharePointListId: currentSharepointFolderInfo?.sharepointListId,
                        folderPath: tryEncodeUriComponent(folderPath)?.replaceAll("'", "''"),
                        template: selectedTemplate,
                        filename: tryEncodeUriComponent(filename)?.replaceAll("'", "''")
                    }).unwrap();

                    if (!tenantDisableAutoOpenAfterNewFileFromTemplate) {
                        editLink = results.value;
                    }
                    newFileId = results.value?.split('sourcedoc={')[1].split('}')[0];

                    const contentTypeMeta: MetadataDto = {
                        type: "Content",
                        internalName: internalSharepointName.contentTypeId,
                        value: selectedContentTypeId
                    }

                    const metadataUpdateRequest: MetadataUpdateRequest = {
                        accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                        tenantGuid: userAccount?.tenantId,
                        accountId: userAccount?.accountId,
                        siteUrl: isInOneDrive.current ? oneDriveRootDetails.sharePointSiteUrl : itemWebUrl,
                        listId: itemSharepointListId,
                        teamId: workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId,
                        channelId: workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId,
                        listItemUniqueId: newFileId,
                        isFolder: selectedItem?.contenttypeid ? selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder) : selectedItem?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder),
                        isListItem: false,
                        listSettings: {
                            enableMinorVersions: currentSharepointFolderInfo?.enableMinorVersions === true,
                        },
                        triggeredByAction: UpdateTriggerAction.NewTemplate,
                        metadata: inputValuesToSave
                            .filter(x => x.internalName !== sharePointInternalFileName)
                            .map(input => {
                                const meta: MetadataDto = {
                                    type: input.type,
                                    internalName: input.internalName,
                                    value: !(input?.value === 0) && (!input?.value || (Array.isArray(input?.value) && !input?.value?.length)) ? undefined : input.value
                                }
                                return meta;
                            })
                    };

                    if (selectedTemplate.extention === 'onetoc') {
                        metadataUpdateRequest.isFolder = true;
                    }

                    metadataUpdateRequest.metadata.unshift(contentTypeMeta);

                    // Ancorus tenant workaround to auto set a specific metadata value until alternative has been found 
                    if (tenantReplaceFileNameWithGUID && siteUrl.toLowerCase().startsWith("https://ancorus")) {
                        metadataUpdateRequest.metadata.push({
                            type: "Text",
                            internalName: "DO_Nummer",
                            value: filename
                        });
                    }

                    await updateOfficeXML();

                    await Promise.all([
                        (async () => {
                            try {
                                setIsUpdateError(false);
                                await apiUpdateItemMetadata(metadataUpdateRequest);
                            } catch (error) {
                                logger(error, "CMFileInfoPanel.tsx (createNewNemplate(updateItemMetadata))");
                                setIsUpdateError(true, error?.response?.data ?? error?.message);
                            }
                        })(),
                        (async () => {
                            if (tenantOpenDocumentsInClientApp && !tenantDisableAutoOpenAfterNewFileFromTemplate) {
                                try {
                                    const absUrl = await getItemAbsoluteUrl(isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(), siteUrl, itemSharepointListId, newFileId);
                                    if (absUrl) {
                                        const fileInfo = SearchOpenExtensionHelper.determineOfficeFileType(selectedTemplate.extention);
                                        if (fileInfo?.localUrlPrepended) {
                                            editLink = `${fileInfo.localUrlPrepended}${absUrl}`;
                                            if (fileInfo.type === officeFileType.Visio && currentSharepointFolderInfo?.forceCheckout) {
                                                allowOpenLink = false;
                                            }
                                        }
                                    }
                                } catch (error) {
                                    logger(error, "CMFileInfoPanel.tsx (getItemAbsoluteUrl)");
                                }
                            }
                        })()
                    ]);
                }

                setIsBusy(false);
                if (editLink && allowOpenLink) {
                    window.open(editLink);
                }
                generalModule.setIsFileInfoPanelOpen(false);
                closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention);
            }
        } catch (error) {
            logger(error, "CMFileInfoPanel.tsx (createNewNemplate)");
        }
        setIsBusy(false);
    }

    const getHeaderFileIcon = () => {
        if (selectedItem?.FSObjType === '0' && isCurrentDirectorySPList) {
            return <Icon
                {...getFileTypeIconProps({
                    type: FileIconType.listItem,
                    size: 20,
                    imageFileType: "svg",
                })}
            />
        }

        if ((selectedItem?.FSObjType === '0' || selectedItem?.FileSystemObjectType === 0 || (selectedItem?.contenttypeid && !selectedItem?.contenttypeid.startsWith(SharePointFolderContentTypeIds.folder)))) {
            return <Icon
                {...getFileTypeIconProps({
                    extension: getFileExtension(),
                    size: 20,
                    imageFileType: "svg",
                })}
            />
        }

        if ((selectedItem?.FSObjType === '1' || selectedItem?.FileSystemObjectType === 1 || selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.folder))) {
            return <Icon
                {...getFileTypeIconProps({
                    type: selectedItem?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.documentSet) || selectedItem?.contenttypeid?.startsWith(SharePointFolderContentTypeIds.documentSet) ? FileIconType.docset : FileIconType.folder,
                    size: 20,
                    imageFileType: "svg",
                })}
            />
        }

        if (selectedTemplate) {
            return <Icon
                {...getFileTypeIconProps({
                    extension: selectedTemplate.extention,
                    size: 20,
                    imageFileType: "svg",
                })}
            />
        }

        // Advanced search item
        if ((selectedItem as any)?.contenttypeid && item?.name) {
            if (!item["contenttypeid"].startsWith(SharePointFolderContentTypeIds.folder)) {
                let extension: string;
                const fileParts = item.name?.split('.');
                if (fileParts?.length > 0) {
                    extension = fileParts[fileParts.length - 1];
                }

                return <Icon {...getFileTypeIconProps({ extension: extension, size: 20, imageFileType: "svg", })} />
            }
            else {
                return <Icon {...getFileTypeIconProps({ type: item["contenttypeid"].startsWith(SharePointFolderContentTypeIds.documentSet) ? FileIconType.docset : FileIconType.folder, size: 20, imageFileType: "svg" })} />
            }
        }

        // Advanced search recent item
        if ((selectedItem as any)?.sizetext) {
            if ((selectedItem as any)?.isdocument) {
                let extension: string;
                const fileParts = item.name?.split('.');
                if (fileParts?.length > 0) {
                    extension = fileParts[fileParts.length - 1];
                }

                return <Icon {...getFileTypeIconProps({ extension: extension, size: 20, imageFileType: "svg", })} />
            }
            else {
                return <Icon {...getFileTypeIconProps({ type: FileIconType.folder, size: 20, imageFileType: "svg" })} />
            }
        }

        return <Icon
            {...getFileTypeIconProps({
                size: 20,
                imageFileType: "svg",
            })}
        />;
    }

    const getHeaderText = () => {
        if (selectedItem) {
            if (selectedItem.FSObjType === "1") {
                return selectedItem.FileLeafRef ?? selectedItem.Title;
            }
            else if (isCurrentDirectorySPList) {
                return selectedItem.Title;
            }
            else {
                return selectedItem?.name ?? selectedItem?.FileLeafRef;
            }
        }
        else if (selectedTemplate) {
            return `${languageStrings.New} ${selectedTemplate.title}`;
        }
        return "";
    }

    const onRenderNavigationContent: IRenderFunction<IPanelProps> = React.useCallback(
        (props, defaultRender) => (
            <>
                <Stack horizontal verticalAlign={"center"} tokens={fileNameContainerTokens} styles={fileNameContainerStyles}>
                    <Stack.Item styles={fileIconContainerStyles}>
                        {getHeaderFileIcon()}
                    </Stack.Item>
                    <Stack.Item grow styles={fileNameTextContainerStyles}>
                        <Label className={fileNameTextStyles}>{getHeaderText()}</Label>
                    </Stack.Item>
                </Stack>
                <div style={defaultCloseButtonContainerStyles}>
                    {defaultRender!(props)}
                </div>
            </>
        ),
        [selectedItem, currentDirectory],
    );

    const getFileExtension = () => {
        if (selectedItem?.name) {
            const fileParts = selectedItem.name?.split('.');
            if (fileParts?.length > 0) {
                return fileParts[fileParts.length - 1];
            }
        }

        return selectedItem?.File_x0020_Type;
    };

    const fieldsChanged = (fields: any[], contentTypeId: string, inputValues?: SharePointInputData[]) => {
        if (isInOneDrive.current) {
            mapColumnsToSaveFieldsOneDrive();
        } else {
            mapColumnsToSaveFields(fields, inputValues);
        }

        if (contentTypeId) {
            setSelectedContentTypeId(contentTypeId);
        }
    }

    const onUploadComplete = (fails: number, successes: number, total: number) => {
    }

    const onUploadClear = () => {
        // Ignore due to Syncfusion component calling Clear on unmount
    }

    const onFileUploaded = (uploadedFile: IFileToUpload) => {
        setReplacementFile(uploadedFile);
    }

    const onReplaceFile = async () => {
        if (currentSharepointFolderInfo?.enableMinorVersions === true && showSelectVersion === false && replacementFile?.extension === selectedItem.File_x0020_Type) {
            setShowSelectVersion(true);
        }
        else {

            setIsBusy(true);

            const isValidSharepointData = await sharepointDataIsValid();
            if (isValidSharepointData) {
                try {
                    let request: ReplaceFileRequest = {
                        accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                        accountId: userAccount?.uniqueId ?? (await authModule.getAccount(false))?.uniqueId,
                        siteUrl: isInOneDrive.current ? oneDriveRootDetails.sharePointSiteUrl : itemWebUrl,
                        listId: itemSharepointListId,
                        fileUniqueId: webAddinItem ? webAddinItem.sharepointIds.listItemUniqueId : selectedItem.uniqueid ?? selectedItem.UniqueId.replace('{', '').replace('}', ''),
                        fileName: `${replacementFile?.name}.${replacementFile?.extension}`,
                        checkinType: currentSharepointFolderInfo?.enableMinorVersions === true ? (checkinType ? checkinType : CheckinTypes.minorCheckIn) : undefined,
                        metadata: inputValuesToSave.map(input => {
                            const meta: MetadataDto = {
                                type: input.type,
                                internalName: input.internalName,
                                value: !(input?.value === 0) && (!input?.value || (Array.isArray(input?.value) && !input?.value?.length)) ? undefined : input.value
                            }
                            return meta;
                        })
                    }

                    if (!generalModule.isInConentMangerMode()) {
                        if (mode === ModeEnum.office) {
                            const officeFile = !replacementFile.originalName && replacementFile;
                            if (officeFile) {
                                let base64Content: string = await FileService.GetFileContent();
                                if (base64Content) {
                                    request.officeFile = { ContentBase64: base64Content, name: officeFile.name, extension: officeFile.extension, id: officeFile.id, isDuplicate: officeFile.isDuplicate === true };
                                }
                            }
                        }
                        else if (mode !== ModeEnum.mailCompose) {
                            const itemId = replacementFile.isAttachment ? replacementFile.parentId : replacementFile.id;
                            if (itemId) {
                                const outlookRestInfo: IOutlookRestDto = {
                                    ewsOnlySupport: OutlookUtils.ewsOnlySupport,
                                    url: await OutlookUtils.getRestURL(),
                                    outlookToken: OutlookUtils.ewsOnlySupport ? await OutlookUtils.getOutlookToken() : undefined,
                                    ewsUrl: OutlookUtils.ewsOnlySupport ? OutlookUtils.getEWSURL() : undefined,
                                    ewsToken: OutlookUtils.ewsOnlySupport ? await OutlookUtils.getEWSToken() : undefined,
                                    mailboxToken: await authModule.getGraphAccessToken(),
                                    mailboxUser: await OutlookUtils.getMailboxAddress(),
                                    isDraft: false
                                };
                                request.outlookRestInfo = outlookRestInfo;
                                request.emailItemId = OutlookService.getItemRestId(mode !== ModeEnum.mailCompose
                                    ? Office.context.mailbox?.item?.itemId
                                    : await OutlookUtils.getComposeModeItemId());
                                request.attachmentFile = replacementFile;
                            }
                        }
                    }

                    const contentTypeMeta: MetadataDto = {
                        type: "Content",
                        internalName: internalSharepointName.contentTypeId,
                        value: selectedContentTypeId
                    }
                    request.metadata.push(contentTypeMeta);

                    await updateOfficeXML();
                    await apiFileReplace(request);
                    generalModule.setIsFileInfoPanelOpen(false);
                    closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention, replacementFile);
                } catch (error) {
                    logger(error, "CMFileInfoPanel.tsx (onReplaceFile)");
                }
            }

            setIsBusy(false);
        }
    }

    const onPanelClose = () => {
        if (generalModule.isInConentMangerMode()) {
            dispatch(resetFiles([]));
        }
        generalModule.setIsFileInfoPanelOpen(false);
        if (!keepOpenOnSave && fileUpdated && closeOnSuccess) {
            closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention);
        }
        closePanel();
    }

    const checkinTypeChanged = (checkinType: CheckinTypes) => {
        setCheckinType(checkinType);
    }

    const saveButtonText: string = React.useMemo(() => {
        if (isBusy || showSaveSuccessIndicator) {
            return languageStrings.SaveInProgress;
        }
        else if (infoPanelMode === InfoPanelMode.NewTemplate) {
            return languageStrings.Create;
        }
        else if (infoPanelMode !== InfoPanelMode.Replace && (requiredMetadataValueChanged || (currentMinorVersion >= (minVersionLimit - 1)))) {
            return languageStrings.Publish;
        }
        return infoPanelMode !== InfoPanelMode.Replace
            ? languageStrings.SaveProperties
            : languageStrings.Save;

    }, [isBusy, showSaveSuccessIndicator, infoPanelMode, requiredMetadataValueChanged, currentMinorVersion, minVersionLimit]);

    const isFilePreviewVisible: boolean = React.useMemo(() => {
        return filePreview && windowSize.width > 1050;
    }, [filePreview, windowSize.width]);

    const previewContainerStyles: IStackItemStyles = React.useMemo(() => {
        if (!isFilePreviewVisible) return undefined;

        return windowSize.width <= 1415
            ? { root: { width: Math.min((windowSize.width - 350), 1050) } }
            : { root: { width: 1050 } }
    }, [isFilePreviewVisible, windowSize.width]);

    return (
        <Panel
            isOpen={panelIsOpen}
            onDismiss={onPanelClose}
            onRenderNavigationContent={onRenderNavigationContent}
            isLightDismiss
            closeButtonAriaLabel="Close"
            type={PanelType.custom}
            customWidth={isFilePreviewVisible
                ? "1400px"
                : (!generalModule.isInConentMangerMode() ? "300px" : "350px")}
            styles={panelStyles}
        >
            <Stack horizontal>
                {isFilePreviewVisible
                    && <Stack.Item styles={previewContainerStyles}>
                        {filePreview}
                    </Stack.Item>}
                <Stack.Item grow>
                    <div className={scrollStyle} >
                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                            <div className="xb-content">
                                {showSelectVersion && versionProps && <React.Fragment>
                                    <VersionSelector level={versionProps.level} majorVersion={versionProps.majorVersion} minorVersion={versionProps.minorVersion} checkinTypeChanged={checkinTypeChanged} multipleFilesSelected={versionProps.multipleFilesSelected} />
                                </React.Fragment>}
                                {!showSelectVersion && <React.Fragment>
                                    {fieldsLoaded && (currentMinorVersion >= (minVersionLimit - 1) && !requiredMetadataValueChanged) && <MessageBar
                                        messageBarType={MessageBarType.warning}
                                        isMultiline={false}
                                        onDismiss={removeMessage}
                                        dismissButtonAriaLabel="Close"
                                    >
                                        {languageStrings.FileVersionLimitReached}
                                    </MessageBar>}
                                    {updateItemErrorDetails?.isError && <MessageBar
                                        messageBarType={MessageBarType.error}
                                        isMultiline={false}
                                        onDismiss={() => setIsUpdateError(false)}
                                        dismissButtonAriaLabel="Close"
                                        truncated={true}
                                    >
                                        {updateItemErrorDetails.details}
                                    </MessageBar>}
                                    {fieldsLoaded && infoPanelMode === InfoPanelMode.Replace && !replacementFile &&
                                        <div style={uploaderContainerStyles}>
                                            {showMessageBar &&
                                                <div style={paddedContainerStyles}>
                                                    <MessageBar
                                                        messageBarType={MessageBarType.warning}
                                                        isMultiline={false}
                                                        onDismiss={removeMessage}
                                                        dismissButtonAriaLabel="Close"
                                                        truncated={true}
                                                    >
                                                        <b>{languageStrings.ReplacementFileRequired}</b> {languageStrings.ReplacementFileRequiredMessage}
                                                    </MessageBar>
                                                </div>}
                                            {selectedOutlookFileViews?.length > 0 && <div style={paddedContainerStyles}>
                                                <Label>{languageStrings.AvailableFiles}</Label>
                                                <div className={sectionStyle}>
                                                    {selectedOutlookFileViews}
                                                </div>
                                                {selectedOutlookFileViews?.length > minItems &&
                                                    <div
                                                        className="xb-show-more-action"
                                                        onClick={() => setShowMore((prevShowMoreIsClicked) => !prevShowMoreIsClicked)}
                                                        style={showMoreContainerStyles}
                                                    >
                                                        <FontIcon iconName={!showMoreIsClicked ? "ChevronDown" : "ChevronUp"} />
                                                        <span>{!showMoreIsClicked ? languageStrings.ShowMore : languageStrings.ShowLess}</span>
                                                    </div>}
                                            </div>}

                                            <UploaderContainer
                                                onComplete={onUploadComplete}
                                                onClear={onUploadClear}
                                                onFileUploaded={onFileUploaded}
                                                enableAutoUpload={true}
                                                allowMultipleFiles={false}
                                            //allowedExtensions={`.${extention}`}
                                            />
                                        </div>}
                                    {infoPanelMode === InfoPanelMode.Replace && replacementFile &&
                                        <div style={paddedContainerStyles}>
                                            {replacementFileView}
                                        </div>
                                    }
                                    {(selectedItem || selectedTemplate) && itemSharepointListId && itemWebUrl && permissionsLoaded && <SaveWithMetaData
                                        isInfoMode={true}
                                        isInOneDrive={isInOneDrive.current}
                                        inputValuesToSave={inputValuesToSave}
                                        updateSharepointMetadataToSave={(metadata: SharePointInputData[], informationProtectionId: string) => updateSharepointMetadataToSave(metadata, informationProtectionId)}
                                        addNameField={!isCurrentDirectorySPList && !tenantReplaceFileNameWithGUID ? true : false}
                                        disableNameField={infoPanelMode === InfoPanelMode.Replace || isCurrentOfficeFile.current === true}
                                        isCreateFromTemplate={infoPanelMode === InfoPanelMode.NewTemplate}
                                        itemContentTypeId={selectedItem?.contenttypeid ?? selectedItem?.ContentTypeId}
                                        itemWebUrl={itemWebUrl}
                                        itemSharepointListId={itemSharepointListId}
                                        fieldsChanged={fieldsChanged}
                                        fieldsLoaded={() => setFieldsLoaded(true)}
                                        userItemPermissions={userPermissionsRef.current}
                                        selectedItem={selectedItem}
                                    ></SaveWithMetaData>}
                                </React.Fragment>}
                            </div>
                        </ScrollablePane>
                    </div>
                    <Stack horizontal horizontalAlign="end" tokens={{ childrenGap: 15 }} style={{ paddingRight: 10 }}>
                        <TooltipHost content={currentSharepointFolderInfo?.userPermissions?.canEditListItem === false && languageStrings.WrongUserPermissionsUpdate} calloutProps={tooltipHostCalloutProps}>
                            <PrimaryButton
                                styles={panelActionButtonStyle}
                                disabled={((infoPanelMode === InfoPanelMode.Replace && !replacementFile)
                                    || isBusy
                                    || showSaveSuccessIndicator)
                                    || currentSharepointFolderInfo?.userPermissions?.canEditListItem === false}
                                iconProps={{ iconName: "save" }}
                                onClick={async () => {
                                    if (infoPanelMode === InfoPanelMode.Update) {
                                        saveMetadata();
                                    }
                                    else if (infoPanelMode === InfoPanelMode.Replace) {
                                        onReplaceFile();
                                    }
                                    else if (infoPanelMode === InfoPanelMode.NewTemplate) {
                                        createNewNemplate();
                                    }
                                }}
                                text={saveButtonText}
                            >
                                {isBusy && <Spinner size={SpinnerSize.small} styles={{ root: { marginLeft: 5 } }} />}
                                {showSaveSuccessIndicator && <FontIcon iconName="CheckMark" style={{ marginLeft: 5, fontSize: 18 }} />}
                            </PrimaryButton>
                        </TooltipHost>
                    </Stack>
                    <ToastContainer autoClose={5000} hideProgressBar transition={Slide}></ToastContainer>
                    {showCheckinDialog && updateRequest &&
                        <CMCheckinModal
                            showDialog={showCheckinDialog}
                            isPublish={true}
                            closeDialog={() => {
                                setShowCheckinDialog(false);
                                setIsBusy(false);
                            }}
                            closeOnSuccess={(updatedInputValues?: SharePointInputData[]) => {
                                setShowCheckinDialog(false);
                                setIsBusy(false);
                                if (keepOpenOnSave) {
                                    if (updatedInputValues?.length > 0) setInputValuesToSave(updatedInputValues);
                                    setShowSaveSuccessIndicator(true);
                                    setFileUpdated(Date.now().toString());
                                }
                                else {
                                    generalModule.setIsFileInfoPanelOpen(false);
                                    closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention);
                                }
                            }}
                            selectedItems={generalModule.isInConentMangerMode() ? [item] : undefined}
                            selectedAddInItems={!generalModule.isInConentMangerMode() ? [webAddinItem] : undefined}
                            isInOneDrive={isInOneDrive.current}
                            fileUpdatePublishInfo={{ request: updateRequest, originalInputValues: inputValuesToSave }}
                            updateOfficeXML={updateOfficeXML}
                        />}
                    {showConfirmPublishDialog && <CMConfirmModal
                        title={languageStrings.FileVersionLimitReached}
                        message={languageStrings.ConfirmPublish}
                        showDialog={showConfirmPublishDialog}
                        closeDialog={async () => {
                            try {
                                setIsBusy(true);
                                setIsUpdateError(false);
                                setShowConfirmPublishDialog(false);
                                await updateOfficeXML();
                                await apiUpdateItemMetadata(updateRequest);
                                setIsBusy(false);
                                if (keepOpenOnSave) {
                                    setShowSaveSuccessIndicator(true);
                                    setFileUpdated(Date.now().toString());
                                }
                                else {
                                    generalModule.setIsFileInfoPanelOpen(false);
                                    closeOnSuccess(selectedItem, inputValuesToSave, selectedContentTypeId, extention);
                                }
                            } catch (error) {
                                logger(error, "CMFileInfoPanel.tsx (confirm modal close)");
                                setIsBusy(false);
                                setIsUpdateError(true, error?.response?.data ?? error?.message);
                            }
                        }}
                        closeText={languageStrings.No}
                        confirmText={languageStrings.Yes}
                        onConfirm={() => {
                            setShowConfirmPublishDialog(false);
                            setShowCheckinDialog(true);
                        }}
                    />}
                </Stack.Item>
            </Stack>
        </Panel>
    )
};